import BusinessSignupContainer from './BusinessSignupContainer';

export default BusinessSignupContainer;
